import React, { useEffect, Children } from "react"
import ReactDOM from "react-dom"
import PropTypes from "prop-types"
import Overlay from "./Overlay"
import classNames from "classnames"

const Modal = ({
  className,
  children,
  open,
  overlayClassName,
  onClose,
  ...otherProps
}) => {
  const modalClassName = classNames("bg-white br-4 o-hidden", className)

  useEffect(() => {
    if (open) {
      document.body.classList.add("o-hidden")
    } else {
      document.body.classList.remove("o-hidden")
    }
  }, [open])

  return (
    <>
      {open &&
        ReactDOM.createPortal(
          <Overlay className={overlayClassName}>
            <div {...otherProps} className={modalClassName}>
              {Children.map(children, child => {
								if(child !== null) return React.cloneElement(child,  {onClose: onClose})
              })}
            </div>
          </Overlay>,
          document.body
        )}
    </>
  )
}

Modal.propTypes = {
  /**
   * Content of the modal
   */
  children: PropTypes.string.isRequired,
  /**
   * Classes to be added to the modal component
   */
  className: PropTypes.string,
  /**
   * Modify open/close state of the modal
   */
  open: PropTypes.bool,
  /**
   * Changes the styles of modal overlay
   */
  overlayClassName: PropTypes.string,
	/**
   * Closes the modal
   */
	 onClose: PropTypes.func,
}

Modal.defaultProps = {
  className: "",
  open: false,
  children: "",
	onClose: ()=> {}
}

Modal.displayName = "Modal"

export default Modal
